/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminNoticeControllerCreate } from '../fn/admin-notice/admin-notice-controller-create';
import { AdminNoticeControllerCreate$Params } from '../fn/admin-notice/admin-notice-controller-create';
import { adminNoticeControllerDelete } from '../fn/admin-notice/admin-notice-controller-delete';
import { AdminNoticeControllerDelete$Params } from '../fn/admin-notice/admin-notice-controller-delete';
import { adminNoticeControllerFindAll } from '../fn/admin-notice/admin-notice-controller-find-all';
import { AdminNoticeControllerFindAll$Params } from '../fn/admin-notice/admin-notice-controller-find-all';
import { adminNoticeControllerFindById } from '../fn/admin-notice/admin-notice-controller-find-by-id';
import { AdminNoticeControllerFindById$Params } from '../fn/admin-notice/admin-notice-controller-find-by-id';
import { adminNoticeControllerSearchCursor } from '../fn/admin-notice/admin-notice-controller-search-cursor';
import { AdminNoticeControllerSearchCursor$Params } from '../fn/admin-notice/admin-notice-controller-search-cursor';
import { adminNoticeControllerSearchOffset } from '../fn/admin-notice/admin-notice-controller-search-offset';
import { AdminNoticeControllerSearchOffset$Params } from '../fn/admin-notice/admin-notice-controller-search-offset';
import { adminNoticeControllerUpdate } from '../fn/admin-notice/admin-notice-controller-update';
import { AdminNoticeControllerUpdate$Params } from '../fn/admin-notice/admin-notice-controller-update';
import { AdminNoticeDto } from '../models/admin-notice-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class AdminNoticeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminNoticeControllerFindAll()` */
  static readonly AdminNoticeControllerFindAllPath = '/api/admin-notice';

  /**
   * 관리자 공지사항 전체 조회.
   *
   * 관리자 공지사항 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminNoticeControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminNoticeControllerFindAll$Response(params?: AdminNoticeControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AdminNoticeDto>>> {
    return adminNoticeControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 공지사항 전체 조회.
   *
   * 관리자 공지사항 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminNoticeControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminNoticeControllerFindAll(params?: AdminNoticeControllerFindAll$Params, context?: HttpContext): Observable<Array<AdminNoticeDto>> {
    return this.adminNoticeControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AdminNoticeDto>>): Array<AdminNoticeDto> => r.body)
    );
  }

  /** Path part for operation `adminNoticeControllerCreate()` */
  static readonly AdminNoticeControllerCreatePath = '/api/admin-notice';

  /**
   * 관리자 공지사항 생성.
   *
   * 관리자 공지사항을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminNoticeControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminNoticeControllerCreate$Response(params: AdminNoticeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminNoticeDto>> {
    return adminNoticeControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 공지사항 생성.
   *
   * 관리자 공지사항을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminNoticeControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminNoticeControllerCreate(params: AdminNoticeControllerCreate$Params, context?: HttpContext): Observable<AdminNoticeDto> {
    return this.adminNoticeControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminNoticeDto>): AdminNoticeDto => r.body)
    );
  }

  /** Path part for operation `adminNoticeControllerSearchOffset()` */
  static readonly AdminNoticeControllerSearchOffsetPath = '/api/admin-notice/search/offset';

  /**
   * 관리자 공지사항 오프셋 기반 조회.
   *
   * 관리자 공지사항을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminNoticeControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminNoticeControllerSearchOffset$Response(params: AdminNoticeControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return adminNoticeControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 공지사항 오프셋 기반 조회.
   *
   * 관리자 공지사항을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminNoticeControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminNoticeControllerSearchOffset(params: AdminNoticeControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.adminNoticeControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `adminNoticeControllerSearchCursor()` */
  static readonly AdminNoticeControllerSearchCursorPath = '/api/admin-notice/search/cursor';

  /**
   * 관리자 공지사항 커서 기반 조회.
   *
   * 관리자 공지사항을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminNoticeControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminNoticeControllerSearchCursor$Response(params: AdminNoticeControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return adminNoticeControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 공지사항 커서 기반 조회.
   *
   * 관리자 공지사항을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminNoticeControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminNoticeControllerSearchCursor(params: AdminNoticeControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.adminNoticeControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `adminNoticeControllerFindById()` */
  static readonly AdminNoticeControllerFindByIdPath = '/api/admin-notice/{id}';

  /**
   * 관리자 공지사항 ID 기반 조회.
   *
   * 관리자 공지사항을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminNoticeControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminNoticeControllerFindById$Response(params: AdminNoticeControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminNoticeDto>> {
    return adminNoticeControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 공지사항 ID 기반 조회.
   *
   * 관리자 공지사항을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminNoticeControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminNoticeControllerFindById(params: AdminNoticeControllerFindById$Params, context?: HttpContext): Observable<AdminNoticeDto> {
    return this.adminNoticeControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminNoticeDto>): AdminNoticeDto => r.body)
    );
  }

  /** Path part for operation `adminNoticeControllerDelete()` */
  static readonly AdminNoticeControllerDeletePath = '/api/admin-notice/{id}';

  /**
   * 관리자 공지사항 삭제.
   *
   * 관리자 공지사항을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminNoticeControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminNoticeControllerDelete$Response(params: AdminNoticeControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminNoticeDto>> {
    return adminNoticeControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 공지사항 삭제.
   *
   * 관리자 공지사항을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminNoticeControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminNoticeControllerDelete(params: AdminNoticeControllerDelete$Params, context?: HttpContext): Observable<AdminNoticeDto> {
    return this.adminNoticeControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminNoticeDto>): AdminNoticeDto => r.body)
    );
  }

  /** Path part for operation `adminNoticeControllerUpdate()` */
  static readonly AdminNoticeControllerUpdatePath = '/api/admin-notice/{id}';

  /**
   * 관리자 공지사항 수정.
   *
   * 관리자 공지사항을(를) 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminNoticeControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminNoticeControllerUpdate$Response(params: AdminNoticeControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminNoticeDto>> {
    return adminNoticeControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 공지사항 수정.
   *
   * 관리자 공지사항을(를) 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminNoticeControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminNoticeControllerUpdate(params: AdminNoticeControllerUpdate$Params, context?: HttpContext): Observable<AdminNoticeDto> {
    return this.adminNoticeControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminNoticeDto>): AdminNoticeDto => r.body)
    );
  }

}
